<template>
	<div class="finance">
		<el-tabs class="eltabs" v-model="activeName">
			<el-tab-pane label="我要提现" name="first">
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
					<el-col :span="22"><div class="grid-content bg-purple red">友情提示：提现将在24小时内到账，银行提现处理时间段位9:00-17:00</div></el-col>
				</el-row>
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
					<el-col :span="3"><div class="grid-content bg-purple">可提现金额：</div></el-col>
					<el-col :span="6"><div class="grid-content bg-purple red"><em>{{bal}}</em></div></el-col>
					<el-col :span="13" ><div class="grid-content bg-purple"></div></el-col>
				</el-row>

				<template v-if="bankId>0">
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
					<el-col :span="3"><div class="grid-content bg-purple">提现账户：</div></el-col>
					<el-col :span="19"><div class="grid-content bg-purple">
					
						【{{banks[0].Value}}】 {{banks[0].BankUser}}  {{banks[0].BankAcc}} <span class="blue addBank" @click="EditBankWindow">修改银行卡</span>

					</div></el-col>
				</el-row>
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
					<el-col :span="3"><div class="grid-content bg-purple">提现金额：</div></el-col>
					<el-col :span="5"><div class="grid-content bg-purple"><el-input-number label="提现金额" v-model="withdrawBal" name="withdrawBal" size="medium" controls-position="right" :controls="false"></el-input-number></div></el-col>
					<el-col :span="14" ><div class="grid-content bg-purple">&nbsp;&nbsp;元</div></el-col>
				</el-row>
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
					<el-col :span="3"><div class="grid-content bg-purple">服务费：</div></el-col>
					<el-col :span="6"><div class="grid-content bg-purple"><em>2.00</em> 元</div></el-col>
					<el-col :span="13" ><div class="grid-content bg-purple"></div></el-col>
				</el-row>
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="24" ><div class="grid-content bg-purple"></div></el-col>
				</el-row>
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
					<el-col :span="3"><div class="grid-content bg-purple">到款时间：</div></el-col>
					<el-col :span="6"><div class="grid-content bg-purple">6月15日 24点前</div></el-col>
					<el-col :span="13" ><div class="grid-content bg-purple"></div></el-col>
				</el-row>
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
					<el-col :span="3"><div class="grid-content bg-purple">支付密码：</div></el-col>
					<el-col :span="5"><div class="grid-content bg-purple"><el-input size="medium" placeholder="请输入支付密码" type="password" v-model="payPass"></el-input> </div></el-col>
					<el-col :span="14"><div class="grid-content bg-purple blue">&nbsp;&nbsp;忘了？</div></el-col>
				</el-row>
				<el-row align="middle" type="flex" class="mtb30"> 
					<el-col :span="11"><div class="grid-content bg-purple jz"><el-button type="primary" size="medium" >确认提现</el-button></div></el-col>
					<el-col :span="13" ><div class="grid-content bg-purple"></div></el-col>
				</el-row>
				</template>
				<template v-else>
					<el-row align="middle" type="flex" class="mtb30"> 
						<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
						<el-col :span="22"><div class="grid-content bg-purple">您还没设置任何提现账户<span class="addBank blue" @click="ShowBankWindow">立即添加</span></div></el-col>
					</el-row>
				</template>
			</el-tab-pane>
			<el-tab-pane label="充值明细" name="second">
				
			</el-tab-pane>
		</el-tabs>

		<!--  添加银行卡  -->
		<bank :isShow="isShowBankWindow" :ID="Id" @on-close="closeBankWindow" @on-success="successBankWindow"></bank>
	</div>
</template>
<style scoped>
	.finance .mb30{ margin-bottom:30px;}
	.finance .ml30{margin-left:30px;}
	.finance .mtb30{ margin:20px 0;}
	.finance .jz{text-align: center;}
	.finance .red{ color:#ff5151;}
	.finance .blue{ color:#5190ff;}
	.finance em{font-weight: bold;}
	.finance .addBank{cursor: pointer; margin-left: 30px;}
</style>
<script>   
	import bank from "../components/bank"
	export default {
		name: 'finance',
		components: {bank: bank},
		methods: {
			closeBankWindow(val){
				this.isShowBankWindow=val;
			},
			ShowBankWindow(){
				this.isShowBankWindow=true;
			},
			EditBankWindow(){
				this.Id=this.banks[0].ID;
				this.isShowBankWindow=true;
			},
			successBankWindow(bankId){
				this.bankList();
			},
			bankList(){
				const self=this;
				var data= this.common.GetlocalStorage("UnLockUserData");
				var obj=JSON.parse(data);
				var userId=obj.UserID;
				self.http.ajaxGet("BankList?UserID="+userId,function(res){
						self.banks=res.Result;
						var length=self.banks.length; 
						if(length>0)
							self.bankId=self.banks[length-1].ID;
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			userBal(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("UserBal?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						self.bal=res.Result;
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}	
					},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			}
		},
		data() {
			return {
				activeName:'first',
				payPass:'',       //支付密码
				withdrawBal:'',   //提现金额
				isShowBankWindow:false,
				bankId: 0,
				banks:[],
				bal:'',
				Id:0
			}
		},
		computed:{
			
		},
		mounted: function () {
			this.bankList();   //绑定银行卡
			this.userBal();    //用户余额
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/finance.vue